// extracted by mini-css-extract-plugin
export default {"DynamicAnswer":"vzA8RwCg","cell":"bGQ5CeU4","field":"BZFfNvE6","submitButton":"OkCQULPc","nextButton":"lst9V_4J","error":"PQ6wVj79"};
    if(module.hot) {
      // 1721070006347
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  